  <template>
    <r-panel :title="title" :button_add="true" @click_add="click_add">
      <r-smart-offer-skin-table ref="table" :items.sync="values" :title="title" :toolbar="false"/>
    </r-panel>    
  </template>


  
  <script>
  
  import VueTypes from "vue-types";
  import { SmartOfferSkin } from "@/modules/redactor/models/smart-offer/core/SmartOfferSkin";
  
  import RPanel from "@/modules/redactor/views/utils/r-panel";
  import RSmartOfferSkinTable from "@/modules/redactor/views/smart-offer/reskin/r-smart-offer-skin-table.vue"; 

  export default {
    name: "r-smart-offer-skin-panel",
    components: {RPanel, RSmartOfferSkinTable}, 
    props: {
      title: VueTypes.string.def("Skins"),
      items: VueTypes.arrayOf(SmartOfferSkin)
    },
    computed: {
      values() {
        if (this.items) {
          return this.items;
        } else {
          let values = [];
          this.$emit("update:items", values);
          return values;
        }
      }
    },
    methods: {
      click_add() {
        this.$refs["table"].row_create();
      }
    }
  }
  
  </script>